import { ApiService } from '../../../shared/service/Apiservice';
import { environment } from '../../../shared/enviroment/environment';
import { ReferralStats, ReferralHistory, CreateReferralRequest } from '../dto/Referral.dto';

export class ReferralService {
  private apiRootServer = environment.api.apiRootServer;
  constructor(private apiService: ApiService) {}

  async getReferralStats(): Promise<{ success: boolean; data?: ReferralStats }> {
  return this.apiService.getRequest('referrals/stats', {}, { apiRoot: this.apiRootServer });
  }

  async getReferralHistory(page = 1, limit = 10): Promise<{ success: boolean; data?: ReferralHistory }> {
  return this.apiService.getRequest('referrals/history', { page, limit }, { apiRoot: this.apiRootServer });
  }

  async createReferral(payload: CreateReferralRequest): Promise<{ success: boolean; message?: string }> {
  return this.apiService.postRequest('referrals', payload, { apiRoot: this.apiRootServer });
  }
}
